import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function AccessDenied({
  title = "Access Restricted",
  message = "Your role does not currently have permission to view or manage this section.",
  requiredPermission,
}: {
  title?: string | undefined;
  message?: string | undefined;
  requiredPermission?: string | undefined;
}) {
  return (
    <div className="grid min-h-[60vh] place-items-center p-6">
      <div className="border-bank-border bg-bank-surface max-w-md space-y-4 rounded-xl border p-6 text-center shadow-sm">
        <div className="bg-bank-attention-wash text-bank-attention-ink mx-auto grid size-12 place-items-center rounded-xl">
          <ShieldAlert className="size-6" aria-hidden="true" />
        </div>
        <div className="space-y-1.5">
          <h2 className="text-bank-ink text-base font-semibold">{title}</h2>
          <p className="text-bank-muted text-sm">{message}</p>
          {requiredPermission && (
            <p className="text-bank-muted font-mono text-[11px]">
              Required capability: <span className="text-bank-accent-ink font-semibold">{requiredPermission}</span>
            </p>
          )}
        </div>
        <div className="pt-2">
          <Link to="/review">
            <Button variant="secondary" size="sm">
              Return to Review
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
